import type { CSSProperties } from "react"

/**
 * Section wrapper style shared by every builder canvas (InlinePreview,
 * BlogPostCanvas, CampaignCanvas) — single source of truth (NOS-260).
 *
 * The wrapper paints NOTHING — every block (and each NOS-152 layout variant)
 * owns its own background, padding, and overlays in the render layer
 * (`wrapWithBackgroundIfNeeded`), so the canvas renders pixel-identical to
 * the public site. Painting type-based gradients/padding here (pre-NOS-151
 * behavior) made the builder diverge from the published page.
 */
export function getSectionStyle(): CSSProperties {
  return {
    position: "relative",
    outlineOffset: -2,
    transition: "outline 0.15s",
    fontFamily: "var(--font-family, Inter, sans-serif)",
  }
}
